import React from "react";

const RateIcon = ({ className = "", size = 24, color = "#1F2937" }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 14l4-4 3 3 6-6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="1.5" />
  </svg>
);

export default RateIcon;
